import React from "react";
import "./CustomSwitch.css"

const CustomSwitch = (props) => {
    if(props.children){
        document.documentElement.style.setProperty('--switch-bg-color', '#336699');
        document.documentElement.style.setProperty('--switch-bg-color1', 'white');
    }else{
        document.documentElement.style.setProperty('--switch-bg-color', '#ccc');
        document.documentElement.style.setProperty('--switch-bg-color1', '#aaa');
    }
    return (
        <>
            <label className="toggle-switch">
                <input type="checkbox"
                    checked={props.checked}
                    onChange={props.changed}
                />
                <span className="switch" />
            </label>
        </>
    )
}

export default CustomSwitch;